"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconClose = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var icon_1 = require("./icon");
exports.IconClose = react_1.default.forwardRef(function (props, ref) { return ((0, jsx_runtime_1.jsxs)(icon_1.Icon, __assign({ viewBox: "0 0 24 24", ref: ref, "data-name": "IconClose" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M20.36 18.95L13.41 12l6.95-6.95-1.41-1.41L12 10.59 5.05 3.64 3.64 5.05 10.59 12l-6.95 6.95 1.41 1.41L12 13.41l6.95 6.95 1.41-1.41z" })] }))); });
exports.IconClose.displayName = 'IconClose';
exports.default = exports.IconClose;
